import { render } from "./CircleMedium.vue?vue&type=template&id=862e753e"
import script from "./CircleMedium.vue?vue&type=script&lang=js"
export * from "./CircleMedium.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CircleMedium.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "862e753e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('862e753e', __exports__)) {
    api.reload('862e753e', __exports__)
  }
  
  module.hot.accept("./CircleMedium.vue?vue&type=template&id=862e753e", () => {
    api.rerender('862e753e', render)
  })

}


export default __exports__